import { FC } from 'react';

import _ from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';

import { FormLabel } from 'components/FormLabel/FormLabel';
import { CROWDING, CROWDING_VALUES } from 'constants/prescriptionOptions';
import { Option } from 'types/select';
import { translate } from 'utils';
import { RemoveCheckedOptions } from 'utils/patientpageUtils';

import ResolveCrowding from './ResolveCrowding';
import RhfCheckboxGroup from '../CheckboxGroup/RhfCheckboxGroup/RhfCheckboxGroup';
import If from '../Generics/If/If';

interface Props {
  isDisabled?: boolean;
}
const Crowding: FC<Props> = ({ isDisabled }) => {
  const {
    control,
    watch,
    formState: { errors }
  } = useFormContext();

  const watchCrowding = watch(
    'treatmentSpecifications.ZenClearUltra.crowding.Crowding'
  );
  const fieldError = _.get(
    errors,
    'treatmentSpecifications.ZenClearUltra.crowding'
  );
  return (
    <div className='flex flex-col'>
      <FormLabel
        label={translate('prescription.step15_crowding')}
        className='md:text-17px mb-4'
        error={!!fieldError}
        name={'crowding'}
      />
      <Controller
        control={control}
        name={'treatmentSpecifications.ZenClearUltra.crowding.Crowding'}
        render={({ field }) => (
          <div className='w-full'>
            <RhfCheckboxGroup
              disabled={isDisabled}
              options={CROWDING}
              name='treatmentSpecifications.ZenClearUltra.crowding.Crowding'
              checkBoxItemFont='md:text-17px text-sm flex flex-col space-y-4'
              labelClassName='mr-14'
              onChange={(data, name, e) => {
                field.onChange(
                  RemoveCheckedOptions(
                    data,
                    CROWDING_VALUES.RESOLVE_CROWDING,
                    e
                  )
                );
              }}
            />
          </div>
        )}
      />
      <If
        condition={watchCrowding?.find(
          (item: Option) => item?.value === CROWDING_VALUES.RESOLVE_CROWDING
        )}
      >
        <div className=' flex flex-row space-x-4 mb-2 bg-GRAY5 p-4 rounded-2xl mt-4'>
          <div className='mt-3 bg-black text-white flex justify-center items-center pt-1  w-6 h-6 rounded-full'>
            <span>U</span>
          </div>
          <div className='w-full'>
            <ResolveCrowding
              isDisabled={isDisabled}
              isLower={false}
              fieldName='treatmentSpecifications.ZenClearUltra.crowding.resolveCrowding.upper'
            />
          </div>
        </div>
        <div className=' flex flex-row space-x-4 mb-2 bg-GRAY5 p-4 rounded-2xl mt-4 '>
          <div className='mt-3 bg-black text-white flex justify-center items-center pt-1  w-6 h-6 rounded-full'>
            <span>L</span>
          </div>
          <div className='w-full'>
            <ResolveCrowding
              isDisabled={isDisabled}
              isLower={true}
              fieldName='treatmentSpecifications.ZenClearUltra.crowding.resolveCrowding.lower'
            />
          </div>
        </div>
      </If>
    </div>
  );
};
export default Crowding;
